"use client";
import { createGlobalStyle } from "styled-components";
import { globalTextStyles } from "../../foundation/typography/index.js";
const RegisterAudiTheme = createGlobalStyle`
    .theme-audi {
  --moller-opacity-on-focus: 0.16;
  --moller-opacity-on-pressed: 0.16;
  --moller-opacity-on-hover: 0.08;
  --moller-opacity-percentage-16: 0.16;
  --moller-opacity-percentage-8: 0.08;
  --moller-elevation-high: 0px 0px 1px 0px #0000003d, 0px 2px 16px 0px #00000014, 0px 8px 48px 0px #0000000f;
  --moller-elevation-medium: 0px 0px 1px 0px #0000003d, 0px 4px 8px 0px #0000000a, 0px 8px 24px 0px #0000000f;
  --moller-elevation-low: 0px 0px 1px 0px #0000003d, 0px 1px 4px 0px #0000000a, 0px 4px 8px 0px #0000000f;
  --moller-elevation-none: 0px 0px 0px 0px #00000000;
  --moller-radius-checkbox: 0px;
  --moller-radius-feedback: 0px;
  --moller-radius-overlay: 0px;
  --moller-radius-picker: 0px;
  --moller-radius-input: 0px;
  --moller-radius-card: 0px;
  --moller-radius-button: 0px;
  --moller-border-radius-full: 999px;
  --moller-border-radius-xx-large: 16px;
  --moller-border-radius-x-large: 12px;
  --moller-border-radius-large: 8px;
  --moller-border-radius-medium: 4px;
  --moller-border-radius-small: 2px;
  --moller-border-radius-none: 0px;
  --moller-stroke-large: 4px;
  --moller-stroke-medium: 2px;
  --moller-stroke-small: 1px;
  --moller-stroke-x-small: 0.5px;
  --moller-type-compact-notice-text-case: uppercase;
  --moller-type-compact-notice-text-decoration: none;
  --moller-type-compact-notice-paragraph-spacing: 0.75rem;
  --moller-type-compact-notice-letter-spacing: 0;
  --moller-type-compact-notice-font-size: 0.75rem;
  --moller-type-compact-notice-line-height: 1.4;
  --moller-type-compact-notice-font-weight: 500;
  --moller-type-compact-notice-font-family: Audi Type;
  --moller-type-compact-label-text-case: none;
  --moller-type-compact-label-text-decoration: none;
  --moller-type-compact-label-paragraph-spacing: 0.625rem;
  --moller-type-compact-label-letter-spacing: 0;
  --moller-type-compact-label-font-size: 0.625rem;
  --moller-type-compact-label-line-height: 1.4;
  --moller-type-compact-label-font-weight: 400;
  --moller-type-compact-label-font-family: Audi Type;
  --moller-type-compact-action-text-case: none;
  --moller-type-compact-action-text-decoration: none;
  --moller-type-compact-action-paragraph-spacing: 0.875rem;
  --moller-type-compact-action-letter-spacing: 0;
  --moller-type-compact-action-font-size: 0.875rem;
  --moller-type-compact-action-line-height: 1.4;
  --moller-type-compact-action-font-weight: 500;
  --moller-type-compact-action-font-family: Audi Type;
  --moller-type-small-description-text-case: none;
  --moller-type-small-description-text-decoration: none;
  --moller-type-small-description-paragraph-spacing: 0.75rem;
  --moller-type-small-description-letter-spacing: 0;
  --moller-type-small-description-font-size: 0.75rem;
  --moller-type-small-description-line-height: 1.4;
  --moller-type-small-description-font-weight: 400;
  --moller-type-small-description-font-family: Audi Type;
  --moller-type-small-link-text-case: none;
  --moller-type-small-link-text-decoration: underline;
  --moller-type-small-link-paragraph-spacing: 1rem;
  --moller-type-small-link-letter-spacing: 0;
  --moller-type-small-link-font-size: 1rem;
  --moller-type-small-link-line-height: 1.4;
  --moller-type-small-link-font-weight: 400;
  --moller-type-small-link-font-family: Audi Type;
  --moller-type-small-body-text-case: none;
  --moller-type-small-body-text-decoration: none;
  --moller-type-small-body-paragraph-spacing: 1rem;
  --moller-type-small-body-letter-spacing: 0;
  --moller-type-small-body-font-size: 1rem;
  --moller-type-small-body-line-height: 1.4;
  --moller-type-small-body-font-weight: 400;
  --moller-type-small-body-font-family: Audi Type;
  --moller-type-small-lead-text-case: none;
  --moller-type-small-lead-text-decoration: none;
  --moller-type-small-lead-paragraph-spacing: 1.25rem;
  --moller-type-small-lead-letter-spacing: 0;
  --moller-type-small-lead-font-size: 1.25rem;
  --moller-type-small-lead-line-height: 1.4;
  --moller-type-small-lead-font-weight: 400;
  --moller-type-small-lead-font-family: Audi Type;
  --moller-type-small-overline-text-case: uppercase;
  --moller-type-small-overline-text-decoration: none;
  --moller-type-small-overline-paragraph-spacing: 1.125rem;
  --moller-type-small-overline-letter-spacing: 0;
  --moller-type-small-overline-font-size: 0.75rem;
  --moller-type-small-overline-line-height: 1.4;
  --moller-type-small-overline-font-weight: Extended Normal;
  --moller-type-small-overline-font-family: Audi Type Extended;
  --moller-type-small-subtitle-text-case: none;
  --moller-type-small-subtitle-text-decoration: none;
  --moller-type-small-subtitle-paragraph-spacing: 1.5rem;
  --moller-type-small-subtitle-letter-spacing: 0;
  --moller-type-small-subtitle-font-size: 1rem;
  --moller-type-small-subtitle-line-height: 1.4;
  --moller-type-small-subtitle-font-weight: Extended Normal;
  --moller-type-small-subtitle-font-family: Audi Type Extended;
  --moller-type-small-headline-text-case: none;
  --moller-type-small-headline-text-decoration: none;
  --moller-type-small-headline-paragraph-spacing: 2.25rem;
  --moller-type-small-headline-letter-spacing: 0;
  --moller-type-small-headline-font-size: 1.5rem;
  --moller-type-small-headline-line-height: 1.4;
  --moller-type-small-headline-font-weight: Extended Normal;
  --moller-type-small-headline-font-family: Audi Type Extended;
  --moller-type-small-display-text-case: none;
  --moller-type-small-display-text-decoration: none;
  --moller-type-small-display-paragraph-spacing: 3rem;
  --moller-type-small-display-letter-spacing: 0;
  --moller-type-small-display-font-size: 2rem;
  --moller-type-small-display-line-height: 1.4;
  --moller-type-small-display-font-weight: Extended Normal;
  --moller-type-small-display-font-family: Audi Type Extended;
  --moller-type-medium-description-text-case: none;
  --moller-type-medium-description-text-decoration: none;
  --moller-type-medium-description-paragraph-spacing: 0.75rem;
  --moller-type-medium-description-letter-spacing: 0;
  --moller-type-medium-description-font-size: 0.75rem;
  --moller-type-medium-description-line-height: 1.4;
  --moller-type-medium-description-font-weight: 400;
  --moller-type-medium-description-font-family: Audi Type;
  --moller-type-medium-link-text-case: none;
  --moller-type-medium-link-text-decoration: underline;
  --moller-type-medium-link-paragraph-spacing: 1rem;
  --moller-type-medium-link-letter-spacing: 0;
  --moller-type-medium-link-font-size: 1rem;
  --moller-type-medium-link-line-height: 1.4;
  --moller-type-medium-link-font-weight: 400;
  --moller-type-medium-link-font-family: Audi Type;
  --moller-type-medium-body-text-case: none;
  --moller-type-medium-body-text-decoration: none;
  --moller-type-medium-body-paragraph-spacing: 1rem;
  --moller-type-medium-body-letter-spacing: 0;
  --moller-type-medium-body-font-size: 1rem;
  --moller-type-medium-body-line-height: 1.4;
  --moller-type-medium-body-font-weight: 400;
  --moller-type-medium-body-font-family: Audi Type;
  --moller-type-medium-lead-text-case: none;
  --moller-type-medium-lead-text-decoration: none;
  --moller-type-medium-lead-paragraph-spacing: 1.5rem;
  --moller-type-medium-lead-letter-spacing: 0;
  --moller-type-medium-lead-font-size: 1.5rem;
  --moller-type-medium-lead-line-height: 1.4;
  --moller-type-medium-lead-font-weight: 400;
  --moller-type-medium-lead-font-family: Audi Type;
  --moller-type-medium-overline-text-case: uppercase;
  --moller-type-medium-overline-text-decoration: none;
  --moller-type-medium-overline-paragraph-spacing: 1.5rem;
  --moller-type-medium-overline-letter-spacing: 0;
  --moller-type-medium-overline-font-size: 1rem;
  --moller-type-medium-overline-line-height: 1.4;
  --moller-type-medium-overline-font-weight: Extended Normal;
  --moller-type-medium-overline-font-family: Audi Type Extended;
  --moller-type-medium-subtitle-text-case: none;
  --moller-type-medium-subtitle-text-decoration: none;
  --moller-type-medium-subtitle-paragraph-spacing: 1.875rem;
  --moller-type-medium-subtitle-letter-spacing: 0;
  --moller-type-medium-subtitle-font-size: 1.25rem;
  --moller-type-medium-subtitle-line-height: 1.4;
  --moller-type-medium-subtitle-font-weight: Extended Normal;
  --moller-type-medium-subtitle-font-family: Audi Type Extended;
  --moller-type-medium-headline-text-case: none;
  --moller-type-medium-headline-text-decoration: none;
  --moller-type-medium-headline-paragraph-spacing: 2.625rem;
  --moller-type-medium-headline-letter-spacing: 0;
  --moller-type-medium-headline-font-size: 1.75rem;
  --moller-type-medium-headline-line-height: 1.4;
  --moller-type-medium-headline-font-weight: Extended Normal;
  --moller-type-medium-headline-font-family: Audi Type Extended;
  --moller-type-medium-display-text-case: none;
  --moller-type-medium-display-text-decoration: none;
  --moller-type-medium-display-paragraph-spacing: 4.5rem;
  --moller-type-medium-display-letter-spacing: 0;
  --moller-type-medium-display-font-size: 3rem;
  --moller-type-medium-display-line-height: 1.4;
  --moller-type-medium-display-font-weight: Extended Normal;
  --moller-type-medium-display-font-family: Audi Type Extended;
  --moller-type-default-notice-text-case: uppercase;
  --moller-type-default-notice-text-decoration: none;
  --moller-type-default-notice-paragraph-spacing: 1rem;
  --moller-type-default-notice-letter-spacing: 0;
  --moller-type-default-notice-font-size: 1rem;
  --moller-type-default-notice-line-height: 1.4;
  --moller-type-default-notice-font-weight: 500;
  --moller-type-default-notice-font-family: Audi Type;
  --moller-type-default-label-text-case: none;
  --moller-type-default-label-text-decoration: none;
  --moller-type-default-label-paragraph-spacing: 0.75rem;
  --moller-type-default-label-letter-spacing: 0;
  --moller-type-default-label-font-size: 0.75rem;
  --moller-type-default-label-line-height: 1.4;
  --moller-type-default-label-font-weight: 400;
  --moller-type-default-label-font-family: Audi Type;
  --moller-type-default-action-text-case: none;
  --moller-type-default-action-text-decoration: none;
  --moller-type-default-action-paragraph-spacing: 1rem;
  --moller-type-default-action-letter-spacing: 0;
  --moller-type-default-action-font-size: 1rem;
  --moller-type-default-action-line-height: 1.4;
  --moller-type-default-action-font-weight: 500;
  --moller-type-default-action-font-family: Audi Type;
  --moller-type-large-description-text-case: none;
  --moller-type-large-description-text-decoration: none;
  --moller-type-large-description-paragraph-spacing: 0.875rem;
  --moller-type-large-description-letter-spacing: 0;
  --moller-type-large-description-font-size: 0.875rem;
  --moller-type-large-description-line-height: 1.4;
  --moller-type-large-description-font-weight: 400;
  --moller-type-large-description-font-family: Audi Type;
  --moller-type-large-link-text-case: none;
  --moller-type-large-link-text-decoration: underline;
  --moller-type-large-link-paragraph-spacing: 1rem;
  --moller-type-large-link-letter-spacing: 0;
  --moller-type-large-link-font-size: 1rem;
  --moller-type-large-link-line-height: 1.4;
  --moller-type-large-link-font-weight: 400;
  --moller-type-large-link-font-family: Audi Type;
  --moller-type-large-body-text-case: none;
  --moller-type-large-body-text-decoration: none;
  --moller-type-large-body-paragraph-spacing: 1rem;
  --moller-type-large-body-letter-spacing: 0;
  --moller-type-large-body-font-size: 1rem;
  --moller-type-large-body-line-height: 1.4;
  --moller-type-large-body-font-weight: 400;
  --moller-type-large-body-font-family: Audi Type;
  --moller-type-large-lead-text-case: none;
  --moller-type-large-lead-text-decoration: none;
  --moller-type-large-lead-paragraph-spacing: 1.75rem;
  --moller-type-large-lead-letter-spacing: 0;
  --moller-type-large-lead-font-size: 1.75rem;
  --moller-type-large-lead-line-height: 1.4;
  --moller-type-large-lead-font-weight: 400;
  --moller-type-large-lead-font-family: Audi Type;
  --moller-type-large-overline-text-case: uppercase;
  --moller-type-large-overline-text-decoration: none;
  --moller-type-large-overline-paragraph-spacing: 1.5rem;
  --moller-type-large-overline-letter-spacing: 0;
  --moller-type-large-overline-font-size: 1rem;
  --moller-type-large-overline-line-height: 1.4;
  --moller-type-large-overline-font-weight: Extended Normal;
  --moller-type-large-overline-font-family: Audi Type Extended;
  --moller-type-large-subtitle-text-case: none;
  --moller-type-large-subtitle-text-decoration: none;
  --moller-type-large-subtitle-paragraph-spacing: 2.25rem;
  --moller-type-large-subtitle-letter-spacing: 0;
  --moller-type-large-subtitle-font-size: 1.5rem;
  --moller-type-large-subtitle-line-height: 1.4;
  --moller-type-large-subtitle-font-weight: Extended Normal;
  --moller-type-large-subtitle-font-family: Audi Type Extended;
  --moller-type-large-headline-text-case: none;
  --moller-type-large-headline-text-decoration: none;
  --moller-type-large-headline-paragraph-spacing: 3rem;
  --moller-type-large-headline-letter-spacing: 0;
  --moller-type-large-headline-font-size: 2rem;
  --moller-type-large-headline-line-height: 1.4;
  --moller-type-large-headline-font-weight: Extended Normal;
  --moller-type-large-headline-font-family: Audi Type Extended;
  --moller-type-large-display-text-case: none;
  --moller-type-large-display-text-decoration: none;
  --moller-type-large-display-paragraph-spacing: 5.25rem;
  --moller-type-large-display-letter-spacing: 0;
  --moller-type-large-display-font-size: 3.5rem;
  --moller-type-large-display-line-height: 1.4;
  --moller-type-large-display-font-weight: Extended Normal;
  --moller-type-large-display-font-family: Audi Type Extended;
  --moller-typeface-brand-display: Audi Type Extended;
  --moller-typeface-text-decoration-strikethrough: line-through;
  --moller-typeface-text-decoration-line: underline;
  --moller-typeface-text-decoration-none: none;
  --moller-typeface-text-case-lowercase: lowercase;
  --moller-typeface-text-case-uppercase: uppercase;
  --moller-typeface-text-case-none: none;
  --moller-typeface-letter-spacing-none: 0;
  --moller-typeface-size-4xl: 3.5rem;
  --moller-typeface-size-3xl: 3rem;
  --moller-typeface-size-xxl: 2rem;
  --moller-typeface-size-xl: 1.75rem;
  --moller-typeface-size-l: 1.5rem;
  --moller-typeface-size-m: 1.25rem;
  --moller-typeface-size-base: 1rem;
  --moller-typeface-size-s: 0.875rem;
  --moller-typeface-size-xs: 0.75rem;
  --moller-typeface-size-xxs: 0.625rem;
  --moller-typeface-weight-bold: 500;
  --moller-typeface-weight-regular: 400;
  --moller-typeface-line-height: 1.4;
  --moller-typeface-brand: Audi Type;
  --moller-color-on-info-container: #000003;
  --moller-color-info-container: #dfdcff;
  --moller-color-on-info: #ffffff;
  --moller-color-info: #556efe;
  --moller-color-on-success-container: #000200;
  --moller-color-success-container: #dbfbdb;
  --moller-color-on-success: #ffffff;
  --moller-color-on-warning-container: #3d1400;
  --moller-color-warning-container: #fff8db;
  --moller-color-on-warning: #000000;
  --moller-color-warning: #ffaa00;
  --moller-color-on-error-container: #030000;
  --moller-color-error-container: #ffdbdb;
  --moller-color-on-error: #ffffff;
  --moller-color-error: #fd2c4e;
  --moller-color-disabled-variant: #ffffff;
  --moller-color-disabled: #e2e5e8;
  --moller-color-on-tertiary-variant: #000000;
  --moller-color-tertiary-variant: #737d86;
  --moller-color-tertiary-container: #ffb6b6;
  --moller-color-tertiary: #f50537;
  --moller-color-on-secondary-container: #000000;
  --moller-color-secondary-container: #e5e5e5;
  --moller-color-on-primary-container: #000000;
  --moller-color-primary-container: #e5e5e5;
  --moller-color-highlight: #796dff;
  --moller-color-interactive: #ffffff;
  --moller-color-success: #26b82b;
  --moller-color-on-disabled-variant: #35383a;
  --moller-color-on-surface-variant: #ffffff;
  --moller-color-surface-variant: #1a1a1a;
  --moller-color-on-loader: #a8b0b9;
  --moller-color-loader: #e2e5e8;
  --moller-color-outline: #56616e;
  --moller-color-on-disabled: #8c96a0;
  --moller-color-on-surface: #ffffff;
  --moller-color-surface: #333333;
  --moller-color-on-inverse-background: #000000;
  --moller-color-inverse-background: #ffffff;
  --moller-color-on-background: #ffffff;
  --moller-color-background: #000000;
  --moller-color-on-tertiary-container: #480000;
  --moller-color-on-tertiary: #480000;
  --moller-color-on-secondary: #f2f2f2;
  --moller-color-secondary: #333333;
  --moller-color-on-primary: #000000;
  --moller-color-primary: #f2f2f2;
  --moller-palette-tertiary-variant-95: #EAECEF;
  --moller-palette-tertiary-variant-90: #D5D8DE;
  --moller-palette-tertiary-variant-80: #C1C6CE;
  --moller-palette-tertiary-variant-70: #ADB3BC;
  --moller-palette-tertiary-variant-60: #99A1AB;
  --moller-palette-tertiary-variant-50: #868F98;
  --moller-palette-tertiary-variant-40: #737D86;
  --moller-palette-tertiary-variant-30: #4B545C;
  --moller-palette-tertiary-variant-20: #252A30;
  --moller-palette-tertiary-variant-10: #13161A;
  --moller-palette-tertiary-95: #FFDBDB;
  --moller-palette-tertiary-90: #FFB6B6;
  --moller-palette-tertiary-80: #FF9292;
  --moller-palette-tertiary-70: #FF6D6D;
  --moller-palette-tertiary-60: #FF4953;
  --moller-palette-tertiary-50: #FF2443;
  --moller-palette-tertiary-40: #F50537;
  --moller-palette-tertiary-30: #AB0013;
  --moller-palette-tertiary-20: #570000;
  --moller-palette-tertiary-10: #480000;
  --moller-palette-interactive-95: #DEDBFF;
  --moller-palette-interactive-90: #BCB6FF;
  --moller-palette-interactive-80: #9A92FF;
  --moller-palette-interactive-70: #796DFF;
  --moller-palette-interactive-60: #5A4DFF;
  --moller-palette-interactive-50: #3D37FF;
  --moller-palette-interactive-40: #2526FE;
  --moller-palette-interactive-30: #0201AB;
  --moller-palette-interactive-20: #000057;
  --moller-palette-interactive-10: #000003;
  --moller-palette-info-95: #DFDCFF;
  --moller-palette-info-90: #BFBDFF;
  --moller-palette-info-80: #A1A3FF;
  --moller-palette-info-70: #8990FF;
  --moller-palette-info-60: #7481FF;
  --moller-palette-info-50: #6376FF;
  --moller-palette-info-40: #556EFE;
  --moller-palette-info-30: #263BAB;
  --moller-palette-info-20: #0A1657;
  --moller-palette-info-10: #000003;
  --moller-palette-success-95: #DBFBDB;
  --moller-palette-success-90: #B6F4B7;
  --moller-palette-success-80: #92E992;
  --moller-palette-success-70: #6DDC6F;
  --moller-palette-success-60: #49CC4C;
  --moller-palette-success-50: #26B82B;
  --moller-palette-success-40: #0DA20D;
  --moller-palette-success-30: #007D00;
  --moller-palette-success-20: #004800;
  --moller-palette-success-10: #000200;
  --moller-palette-warning-95: #fff8db;
  --moller-palette-warning-90: #fff0b6;
  --moller-palette-warning-80: #ffe692;
  --moller-palette-warning-70: #FFD771;
  --moller-palette-warning-60: #FFCA41;
  --moller-palette-warning-50: #FFAB00;
  --moller-palette-warning-40: #FFAA00;
  --moller-palette-warning-30: #A54600;
  --moller-palette-warning-20: #6B2400;
  --moller-palette-warning-10: #3D1400;
  --moller-palette-error-95: #FFDBDB;
  --moller-palette-error-90: #FFB6B6;
  --moller-palette-error-80: #FF9292;
  --moller-palette-error-70: #FF6D78;
  --moller-palette-error-60: #FF5365;
  --moller-palette-error-50: #FF3D58;
  --moller-palette-error-40: #FD2C4E;
  --moller-palette-error-30: #AB0622;
  --moller-palette-error-20: #570008;
  --moller-palette-error-10: #030000;
  --moller-palette-neutral-variant-95: #F8FAFD;
  --moller-palette-neutral-variant-90: #F1F6FB;
  --moller-palette-neutral-variant-80: #EAF1F8;
  --moller-palette-neutral-variant-70: #E4ECF5;
  --moller-palette-neutral-variant-60: #DEE7F1;
  --moller-palette-neutral-variant-50: #D9E3ED;
  --moller-palette-neutral-variant-40: #D4DEE9;
  --moller-palette-neutral-variant-30: #9FA7AF;
  --moller-palette-neutral-variant-20: #6A6F75;
  --moller-palette-neutral-variant-10: #35383A;
  --moller-palette-neutral-95: #e2e5e8;
  --moller-palette-neutral-90: #c4cad1;
  --moller-palette-neutral-80: #a8b0b9;
  --moller-palette-neutral-70: #8c96a0;
  --moller-palette-neutral-60: #707c87;
  --moller-palette-neutral-50: #56616e;
  --moller-palette-neutral-40: #3b4754;
  --moller-palette-neutral-30: #2c353f;
  --moller-palette-neutral-20: #1e242a;
  --moller-palette-neutral-10: #0f1215;
  --moller-palette-secondary-95: #f2f2f2;
  --moller-palette-secondary-90: #e5e5e5;
  --moller-palette-secondary-80: #cccccc;
  --moller-palette-secondary-70: #b3b3b3;
  --moller-palette-secondary-60: #808080;
  --moller-palette-secondary-50: #666666;
  --moller-palette-secondary-40: #333333;
  --moller-palette-secondary-30: #262626;
  --moller-palette-secondary-20: #1a1a1a;
  --moller-palette-secondary-10: #000000;
  --moller-palette-primary-95: #F2F2F2;
  --moller-palette-primary-90: #E5E5E5;
  --moller-palette-primary-80: #CCCCCC;
  --moller-palette-primary-70: #B3B3B3;
  --moller-palette-primary-60: #808080;
  --moller-palette-primary-50: #666666;
  --moller-palette-primary-40: #333333;
  --moller-palette-primary-30: #262626;
  --moller-palette-primary-20: #1A1A1A;
  --moller-palette-primary-10: #000000;
  --moller-palette-white: #ffffff;
  --moller-palette-black: #000000;
  --moller-keycolor-tertiary-variant: #737D86;
  --moller-keycolor-interactive: #2526FE;
  --moller-keycolor-info: #556EFE;
  --moller-keycolor-success: #26B82B;
  --moller-keycolor-warning: #FFAA00;
  --moller-keycolor-error: #FD2C4E;
  --moller-keycolor-neutral-variant: #D4DEE9;
  --moller-keycolor-neutral: #56616e;
  --moller-keycolor-tertiary: #F50537;
  --moller-keycolor-secondary: #333333;
  --moller-keycolor-primary: #000000;
  --moller-size-4xl: 64px;
  --moller-size-3xl: 48px;
  --moller-size-xxl: 40px;
  --moller-size-xl: 32px;
  --moller-size-l: 24px;
  --moller-size-m: 20px;
  --moller-size-s: 16px;
  --moller-size-xs: 12px;
  --moller-size-xxs: 8px;
  --moller-size-base: 4px;
  --moller-spacing-3xl: 48px;
  --moller-spacing-xxl: 40px;
  --moller-spacing-xl: 32px;
  --moller-spacing-l: 24px;
  --moller-spacing-m: 20px;
  --moller-spacing-s: 16px;
  --moller-spacing-xs: 12px;
  --moller-spacing-xxs: 8px;
  --moller-spacing-base: 4px;
  --moller-spacing-none: 0px;
  ${globalTextStyles}
    }
`;
export {
  RegisterAudiTheme
};
